module.exports = __webpack_public_path__ + "img/jtj.ee894fc5.png";